import { createRouter, createWebHistory } from 'vue-router';
// import routes from './routes';
import { roleRoutes, roles } from 'src/config/roles-config';

import { getStore } from 'src/utils/store-bridge';
import routes from './routes/index';
const router = createRouter({
  routes: routes,
  history: createWebHistory(),
});

export const baseUrls = [
  // 'localhost:8080',
  `fix-azure-sign-problem-large-context-size.dev.retrocausal.tech`,
  `fix-org-name-domain-changes.dev.retrocausal.tech`,
  'test.retrocausal.tech',
  `retrocausal.tech`,
];

// `overlay-bboxes.dev.retrocausal.tech`
// retrocausal.fix-org-name-domain-changes.dev.retrocausal.tech

function getOTPAuthValues() {
  try {
    const isOtpSetup = JSON.parse(
      getStore()?.getters?.isOtpSetup || localStorage.getItem('isOtpSetup')
    );
    const require_otp = JSON.parse(
      getStore()?.getters?.require_otp || localStorage.getItem('require_otp')
    );

    return { isOtpSetup, require_otp };
  } catch {
    const isOtpSetup = false;
    const require_otp = false;
    return { isOtpSetup, require_otp };
  }

  // return { isOtpSetup: true, credentialCheckFlag: true };
}

export function redirectFromOrgToBaseUrl(logout) {
  const queryParams = new URLSearchParams(window.location.search);

  setTimeout(() => {
    if (queryParams.get('config')) {
      return;
    }
    if (!parseUrl().baseUrl || window.location.hostname === '127.0.0.1') {
      window.location.href = `http://localhost:8080?${
        logout ? `logout=true` : `organization=true`
      }`;
      return;
    }
    window.location.href = `https://${parseUrl().baseUrl}?${
      logout ? `logout=true` : `organization=true`
    }`;
  }, 1000);
}

export function redirectFromBaseToOrgUrl() {
  let encodedData = encodeURIComponent(JSON.stringify({ ...localStorage }));
  let host = parseUrl().baseUrl;
  let organization = localStorage.getItem('organizationName');
  if (host == 'localhost:8080') {
    window.location.href = `http://127.0.0.1:8080?config=${encodedData}`;
    return;
  }
  window.location.href = `https://${organization}.${host}?config=${encodedData}`;
}

export function isOrgUrl(organization) {
  return parseUrl().subdomain == `${organization}.`;
}

export function isBaseUrl() {
  return !parseUrl().subdomain && parseUrl().baseUrl;
}

export function parseUrl() {
  let url = window.location.host.replace('www.', '');

  const sortedBaseUrls = [...baseUrls].sort((a, b) => b.length - a.length);
  if (
    url.endsWith('.dev.retrocausal.tech') &&
    !baseUrls.find((eachUrl) => eachUrl == url)
  ) {
    return { baseUrl: null, subdomain: null };
  }
  let baseUrl = null;
  for (const candidate of sortedBaseUrls) {
    if (url.endsWith(candidate)) {
      baseUrl = candidate;
      break;
    }
  }

  if (!baseUrl) {
    return { baseUrl: null, subdomain: null };
  }

  // Extract subdomain
  let subdomain = url.slice(0, url.length - baseUrl.length);

  if (subdomain === 'admin.' && baseUrl == 'retrocausal.tech') {
    return { baseUrl: null, subdomain: null };
  }

  if (subdomain && !subdomain.endsWith('.')) {
    let nextDotIndex = baseUrl.indexOf('.'); // Find the first `.` in baseUrl

    if (nextDotIndex !== -1) {
      subdomain += baseUrl.slice(0, nextDotIndex + 1); // Move characters until next `.` in baseUrl
      baseUrl = baseUrl.slice(nextDotIndex + 1); // Adjust baseUrl
    }
  }

  return { baseUrl, subdomain };
}

router.beforeEach(async (to, from, next) => {
  const queryParams = new URLSearchParams(window.location.search);
  // Note: Don't remove redirectUrl here - it should be preserved until after login

  // Handle config param FIRST, before any other guard logic.
  // This prevents race conditions where isValidRole dispatches clearState
  // (queuing router.replace to /login) before config data is written to localStorage.
  if (queryParams.get('config')) {
    await handleConfigParam();
    return;
  }

  if (to.path === '/login' && parseUrl().subdomain) {
    redirectFromOrgToBaseUrl(false);
    return;
  }

  if (
    isBaseUrl() &&
    localStorage.getItem('organization') &&
    !queryParams.get('logout') &&
    to.path !== '/organizations'
  ) {
    // redirectFromBaseToOrgUrl();
    if (window.location.hostname == 'localhost') {
      window.location.href = `http://${window.location.hostname}:8080/organizations`;
    } else {
      window.location.href = `https://${window.location.hostname}/organizations`;
    }
    return;
  }

  const isTokenSet =
    getStore()?.getters?.isTokenSet || Boolean(localStorage.getItem('token'));
  const role = getStore()?.getters?.role || localStorage.getItem('role');
  const { isOtpSetup, require_otp } = getOTPAuthValues();
  const isAzureLogin = getStore()?.getters?.azureLogin;

  if (
    !require_otp &&
    isOtpSetup &&
    isTokenSet &&
    to.path.includes('/reset-password/') &&
    !queryParams.get('config') &&
    !queryParams.get('organization')
  ) {
    localStorage.clear();
    getStore()?.dispatch('changeRoute', [to.name]);
    next();
  }

  if (
    !isLoginOrSignup(to) &&
    isValidRole(role, to) &&
    !isTokenSet &&
    !queryParams.get('config') &&
    !queryParams.get('organization')
  ) {
    // Save the intended URL before clearing state so we can redirect after login
    // Only save meaningful paths (not root or auth-related query params)
    const isRootPath = to.path === '/';
    const hasAuthQueryParam =
      to.fullPath?.includes('organization=') ||
      to.fullPath?.includes('logout=') ||
      to.fullPath?.includes('config=');
    // Check if there's already a valid redirectUrl saved - don't overwrite it
    const existingRedirectUrl = localStorage.getItem('redirectUrl');
    const hasValidExistingRedirect =
      existingRedirectUrl &&
      existingRedirectUrl !== '/' &&
      !existingRedirectUrl.startsWith('/?') &&
      !existingRedirectUrl.includes('organization=') &&
      !existingRedirectUrl.includes('logout=') &&
      !existingRedirectUrl.includes('config=');
    if (
      !isRootPath &&
      !isLoginOrSignup(to) &&
      !hasAuthQueryParam &&
      !hasValidExistingRedirect
    ) {
      localStorage.setItem('redirectUrl', to.fullPath);
    }
    getStore()?.dispatch('clearState');
  }

  if (
    require_otp &&
    isOtpSetup &&
    isTokenSet &&
    !queryParams.get('config') &&
    !queryParams.get('organization')
  ) {
    getStore()?.dispatch('clearState');
  }

  if (
    !isAzureLogin &&
    !require_otp &&
    isOtpSetup &&
    isTokenSet &&
    to.path.includes('otp-selection')
  ) {
    return redirectToAccuratePath(role, next);
  }

  if (
    !isAzureLogin &&
    isTokenSet &&
    !isOtpSetup &&
    !to.path.includes('otp-selection') &&
    !to.path.includes('privacy-policy')
  ) {
    //return next({ name: 'OTP Selection' });
  }

  if (
    !isAzureLogin &&
    !require_otp &&
    isTokenSet &&
    isLoginOrSignup(to) &&
    !to.path.includes('privacy-policy') &&
    !to.path.includes('otp-selection')
  ) {
    return redirectToAccuratePath(role, next);
  }

  if (to.path === '/') {
    return redirectToAccuratePath(role, next);
  }

  const { authorize } = to.meta;

  if (
    !require_otp &&
    isTokenSet &&
    !authorize?.includes(role) &&
    !to.path.includes('privacy-policy') &&
    !to.path.includes('otp-selection') &&
    !to.path.includes('change-password')
  ) {
    return redirectToAccuratePath(role, next);
  }
  getStore()?.dispatch('changeRoute', [to.matched[to.matched.length - 1].name]);
  next();
});

async function removeParamsAndReroute() {
  setTimeout(() => {
    const newUrl = window.location.pathname;
    window.history.replaceState(null, '', newUrl);
    window.location.href = newUrl;
  }, 0);
}

async function handleConfigParam() {
  const queryParams = new URLSearchParams(window.location.search);
  if (queryParams.get('config')) {
    const encodedData = queryParams.get('config');
    const localStorageData = JSON.parse(decodeURIComponent(encodedData));

    Object.entries(localStorageData).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
    // Don't overwrite organization - it's already set correctly in localStorageData
    // The subdomain is organizationName (display name), not organization (PK)
    await removeParamsAndReroute();
    return true;
  }
  return false;
}

async function handleLogoutParam(next) {
  const queryParams = new URLSearchParams(window.location.search);
  if (queryParams.get('logout')) {
    await removeParamsAndReroute();
    getStore()?.dispatch('clearState');

    next({ path: '/login' });
    return true;
  }
  return false;
}

function handleRoleRedirect(role, next) {
  if (!roleRoutes[role]) {
    getStore()?.dispatch('clearState');
    if (isOrgUrl(localStorage.getItem('organizationName'))) {
      return;
    }
    return next({ path: '/login' });
  }

  // Check if there's a saved redirect URL from before login
  const redirectUrl = localStorage.getItem('redirectUrl');
  if (redirectUrl) {
    // Clear the saved URL so it's not used again
    localStorage.removeItem('redirectUrl');
    // Redirect to the originally intended URL
    return next({ path: redirectUrl });
  }

  // Default: redirect to the role's default route
  next({ name: roleRoutes[role] });
}

async function redirectToAccuratePath(role, next) {
  // Config param is handled at the top of beforeEach guard.
  if (await handleLogoutParam(next)) return;
  handleRoleRedirect(role, next);
}

function isSessionExpired() {
  var minutesDifference = calculateTimeDifference();

  if (minutesDifference > 24) {
    getStore()?.dispatch('clearState');
  }
}

function calculateTimeDifference() {
  let timestamp = localStorage.getItem('timestamp');
  let currentDate = new Date();
  let lastLogin = new Date(timestamp);

  let difference = currentDate - lastLogin;
  let minutesDifference = Math.floor(difference / 1000 / 60 / 60);
  // let minutesDifference = Math.floor(difference / 1000);
  return minutesDifference;
}

function isLoginOrSignup(to) {
  return [
    '/login',
    '/admin-login',
    '/signup',
    '/privacy-policy',
    '/resend-verification',
    '/verify-email/',
    // '/otp-selection',
    // '/verify-otp',
    '/forgot-password',
    '/reset-password',
  ].some((url) => to.path.includes(url));
}

function isValidRole(role, to) {
  if (!Object.values(roles).includes(role)) {
    // Save the intended URL before clearing state so we can redirect after login
    // Only save if it's a meaningful path (not just '/' or '/?organization=true')
    const isRootPath = to?.path === '/';
    const hasAuthQueryParam =
      to?.fullPath?.includes('organization=') ||
      to?.fullPath?.includes('logout=') ||
      to?.fullPath?.includes('config=');

    // Check if there's already a valid redirectUrl saved - don't overwrite it
    const existingRedirectUrl = localStorage.getItem('redirectUrl');
    const hasValidExistingRedirect =
      existingRedirectUrl &&
      existingRedirectUrl !== '/' &&
      !existingRedirectUrl.startsWith('/?') &&
      !existingRedirectUrl.includes('organization=') &&
      !existingRedirectUrl.includes('logout=') &&
      !existingRedirectUrl.includes('config=');

    if (
      to &&
      !isLoginOrSignup(to) &&
      !isRootPath &&
      !hasAuthQueryParam &&
      !hasValidExistingRedirect
    ) {
      localStorage.setItem('redirectUrl', to.fullPath);
    }
    getStore()?.dispatch('clearState');
    return false;
  }
  return true;
}

function getClosestMatchingRouteName(matchedRoutes, currentPath) {
  let closestMatch = null;
  let closestMatchLength = -1;

  matchedRoutes.forEach((route) => {
    if (currentPath === route.path) {
      closestMatch = route.name;
      return;
    }

    const routePathSegments = route.path.split('/');
    const currentPathSegments = currentPath.split('/');

    if (routePathSegments.length <= currentPathSegments.length) {
      let isMatch = true;
      for (let i = 0; i < routePathSegments.length; i++) {
        if (
          routePathSegments[i] !== currentPathSegments[i] &&
          routePathSegments[i][0] !== ':'
        ) {
          isMatch = false;
          break;
        }
      }

      if (isMatch && routePathSegments.length > closestMatchLength) {
        closestMatch = route.name;
        closestMatchLength = routePathSegments.length;
      }
    }
  });

  return closestMatch;
}

export default router;
